<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <div
        class="content-area-wrapper"
        :class="[contentWidth === 'boxed' ? 'container p-0' : null, handleMarginBanner()]"
      >
        <slot name="breadcrumb">
          <app-breadcrumb />
        </slot>
        <portal-target
          name="content-renderer-sidebar-left"
          slim
        />
        <div class="content-right">
          <div class="content-wrapper">
            <div class="content-body">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { getUserData } from '@/libs/utils/user';

export default {
  components: {
    AppBreadcrumb,
  },
  methods: {
    handleMarginBanner() {
      if (this.metaInfo() === null) {
        return 'mt-6-custom-alert-creator'
      }
    },
    metaInfo() {
      return getUserData() && getUserData().meta_info
    }
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style lang="scss">
.mt-6-custom-alert-creator {
  margin-top: 6em;
  @media(max-width: 1199px) {
    margin-top: 9em;
  }
  @media(max-width: 761px) {
    margin-top: 11em;
  }
  @media(max-width: 475px) {
    margin-top: 13em;
  }
  @media(max-width: 371px) {
    margin-top: 14.55em;
  }
  @media(max-width: 356px) {
    margin-top: 16em;
  }
}
